import { render, staticRenderFns } from "./TeamCreateForm.vue?vue&type=template&id=1011d456&scoped=true"
import script from "./TeamCreateForm.vue?vue&type=script&lang=js"
export * from "./TeamCreateForm.vue?vue&type=script&lang=js"
import style0 from "./TeamCreateForm.vue?vue&type=style&index=0&id=1011d456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011d456",
  null
  
)

export default component.exports